export class ProductFilterGroup {
  name: string;
  displayOrder: number;
  filters: ProductFilter[]
}

export class ProductFilter {
  noSelected: number;
  name: string;
  displayOrder: number;
  options: ProductFilterOption[];
}

export class ProductFilterOption {
  checked: boolean;
  specificationAttributeId: number;
  specificationAttributeName: string;
  name: string;
  colorSquaresRgb: string;
  imageUrl: string;
  displayOrder: number;
  attributeTypeId: number;
  disabled: boolean;
}
